import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Container,
} from '@mui/material';
import api from '../../utils/api';

const Settings = () => {
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleDeleteDB = async () => {
    try {
      const res = await api.post(`/api/master/delete-database`);
      alert(res.data.message);
      setOpenConfirm(false);
    } catch (err) {
      console.log('Failed to delete DB:', err);
      alert('Database deletion failed');
    }
  };

  return (
    <Container maxWidth="md">
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      {/* 🔴 Danger Zone */}
      <Box mt={4}>
        <Paper
          elevation={3}
          sx={{ p: 3, border: '1px solid #e53935', backgroundColor: '#fff5f5' }}
        >
          <Typography variant="h6" color="error">
            Danger Zone
          </Typography>
          <Divider sx={{ my: 2 }} />

          <Typography variant="body1" sx={{ mb: 2 }}>
            Deleting the database will erase all your data permanently. A backup
            will be created and saved to Google Drive before deletion.
          </Typography>

          <Button
            variant="contained"
            color="error"
            onClick={() => setOpenConfirm(true)}
          >
            Delete Entire Database
          </Button>
        </Paper>
      </Box>

      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to <strong>delete the entire database</strong>
            ? This action is <u>irreversible</u> and will create a backup in
            Google Drive.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleDeleteDB}>
            Yes, Delete & Backup
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Settings;
